import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@iconify/react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';

function CompanyPage() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: '#000000',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <Navigation />

      {/* Case Studies */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: '#0a0a0a',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div className="responsive-container">
          <h2 className="responsive-heading" style={{
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 'clamp(2rem, 5vw, 3rem)'
          }}>
            案例數據
          </h2>

          <div className="responsive-grid" style={{
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: 'clamp(1rem, 3vw, 2rem)'
          }}>
            {[
              { stat: '2.5x', label: '平均互動率提升', desc: '測試用戶 30 位' },
              { stat: '70%', label: '時間節省', desc: '相比人工文案創作' },
              { stat: '200萬+', label: '觸及人次', desc: '30 天內，10 個帳號' }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  textAlign: 'center',
                  padding: 'clamp(1.5rem, 4vw, 2rem)',
                  background: "rgba(26, 26, 46, 0.6)",
                  borderRadius: 'clamp(12px, 2vw, 16px)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
              >
                <div style={{
                  fontSize: 'var(--font-3xl)',
                  fontWeight: '700',
                  color: '#87CEEB',
                  marginBottom: '0.5rem'
                }}>
                  {item.stat}
                </div>
                <div style={{ fontSize: 'var(--font-xs)', marginBottom: '0.5rem' }}>{item.label}</div>
                <div style={{ fontSize: 'var(--font-xxs)', color: 'var(--text-tertiary)' }}>{item.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: 'rgba(30, 30, 46, 0.5)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div className="responsive-container">
          <h2 className="responsive-heading" style={{
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 'clamp(2rem, 5vw, 3rem)'
          }}>
            他們的成功故事
          </h2>

          <div className="responsive-grid" style={{
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: 'clamp(1.5rem, 4vw, 2rem)'
          }}>
            {[
              {
                quote: "ViralArc.ai 讓我們從每週 20 則手動內容，轉變為每天 50 則自動生成，轉換率提升 3x！",
                author: "行銷主管",
                org: "DTC 品牌"
              },
              {
                quote: "作為獨立創作者，這工具節省了我 90% 時間，讓我專注於互動與成長。",
                author: "健身 blogger",
                org: null
              },
              {
                quote: "企業級一致性完美，跨團隊協作無縫，值得每分錢。",
                author: "IT 總監",
                org: "大型企業"
              }
            ].map((testimonial, index) => (
              <div
                key={index}
                style={{
                  background: '#0a0a0a',
                  padding: 'clamp(1.5rem, 4vw, 2rem)',
                  borderRadius: 'clamp(12px, 2vw, 16px)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  textAlign: 'center',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = '0 10px 30px rgba(135, 206, 235, 0.2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <p style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: 'var(--font-xs)',
                  marginBottom: 'clamp(1rem, 3vw, 1.5rem)',
                  lineHeight: '1.6',
                  fontStyle: 'italic'
                }}>
                  "{testimonial.quote}"
                </p>
                <p style={{
                  color: '#ffffff',
                  fontSize: 'var(--font-xs)',
                  fontWeight: '600'
                }}>
                  {testimonial.author}{testimonial.org ? `, ${testimonial.org}` : ''}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={{
        padding: 'clamp(3rem, 8vw, 5rem) clamp(1rem, 5vw, 5%)',
        background: '#0a0a0a',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div className="responsive-container">
          <h2 className="responsive-heading" style={{
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: 'clamp(2rem, 5vw, 3rem)'
          }}>
            常見問題解答
          </h2>

          <div style={{
            maxWidth: '800px',
            margin: '0 auto',
            marginBottom: 'clamp(2rem, 5vw, 3rem)'
          }}>
            {[
              {
                q: "需要準備什麼資料？",
                a: "僅需關鍵字、品牌語氣、受眾描述與發佈規則。我們的 AI 會自動處理其餘部分。"
              },
              {
                q: "啟動需要多久？",
                a: "接入後不到 24 小時，即可完成初始設定並開始自動產出內容。"
              },
              {
                q: "如何確保品牌語氣一致？",
                a: "可上傳自訂詞庫與禁用詞，AI 將精準適配您的品牌調性，達成 100% 一致。"
              },
              {
                q: "支援哪些平台？",
                a: "目前 Threads 已上線；Instagram、Facebook、Twitter 將於 2026 年全面開放。"
              },
              {
                q: "是否支援自訂圖像與模板？",
                a: "是的，可自由上傳品牌模板，AI 一鍵適配並生成一致內容。"
              },
              {
                q: "資料安全如何保障？",
                a: "我們提供審核流程、操作日誌與權限控制，確保企業級安全。"
              },
              {
                q: "如果不滿意怎麼辦？",
                a: "所有方案提供 30 天無條件退款保證，讓您無風險試用。"
              }
            ].map((faq, index) => (
              <div
                key={index}
                style={{
                  background: 'rgba(30, 30, 46, 0.5)',
                  padding: 'clamp(1rem, 3vw, 1.5rem)',
                  borderRadius: 'clamp(8px, 2vw, 12px)',
                  marginBottom: '1rem',
                  border: '1px solid rgba(255,255,255,0.1)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(135, 206, 235, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                }}
              >
                <h3 style={{
                  fontSize: 'var(--font-xs)',
                  fontWeight: '600',
                  color: '#ffffff',
                  marginBottom: '0.5rem'
                }}>
                  {faq.q}
                </h3>
                <p style={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: 'var(--font-xs)',
                  lineHeight: '1.6',
                  margin: 0
                }}>
                  {faq.a}
                </p>
              </div>
            ))}
          </div>

          <div style={{ textAlign: 'center' }}>
            <button
              onClick={() => navigate('/register')}
              style={{
                background: '#87CEEB',
                border: 'none',
                color: 'white',
                padding: 'clamp(0.75rem, 2vw, 1rem) clamp(2rem, 5vw, 3rem)',
                borderRadius: '12px',
                fontSize: 'var(--font-xs)',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: '0 8px 20px rgba(135, 206, 235, 0.3)',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 12px 24px rgba(135, 206, 235, 0.4)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 8px 20px rgba(135, 206, 235, 0.3)';
              }}
            >
              立即申請 Beta - 開始您的轉型之旅
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default CompanyPage;
